export default __webpack_public_path__ + "static/media/logo-black.1717a1bc.png";